import axios from "axios";
import { getAuth } from "firebase/auth";

const API_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

export default class UserAuthService {
/**
 * 🔹 Проверяет статус пользователя.
 * @param {string} userId - Идентификатор пользователя.
 * @param {number} provider - Провайдер входа (1 - телефон, 3 - Google, 4 - Apple, 5 - Email).
 * @returns {Promise<Object|null>}
 */
static async checkUserStatus(userId, provider) {

  try {

    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      console.error(
        "❌ Firebase currentUser отсутствует"
      );

      return null;
    }


    // =============================
    //       🔐 FIREBASE TOKEN
    // =============================

    const token =
      await user.getIdToken(true);


    const response =
      await axios.post(
        `${API_URL}/handle_user_login`,

        {
          /*
           * user_id можно оставить пока
           * для совместимости/debug,
           * но backend его больше
           * НЕ использует для авторизации.
           */
          user_id: userId,

          provider
        },

        {
          headers: {
            "Content-Type":
              "application/json",

            Authorization:
              `Bearer ${token}`,
          }
        }
      );


    if (response.data?.error) {

      console.error(
        "❌ Ошибка сервера:",
        response.data.error
      );

      return null;
    }


    console.log(
      "✅ Статус пользователя:",
      response.data
    );


    return response.data;

  } catch (error) {

    console.error(
      "❌ Ошибка при запросе "
      + "статуса пользователя:",
      error.response?.data
      || error
    );

    return null;
  }
}

  static async deleteAccount() {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) throw new Error("❌ Нет активного пользователя!");

      // получаем свежий idToken от Firebase
      const idToken = await user.getIdToken(/* forceRefresh */ true);

      console.log("🗑 Отправляем запрос на удаление аккаунта через API...");

      const response = await axios.post(
        `${API_URL}/delete_user_account`,
        {}, 
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
          }
        }
      );

      console.log("✅ Аккаунт успешно удалён:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при удалении аккаунта:", error.response?.data || error.message);
      throw error;
    }
  }
}